import BaseWidget from '../base-widget/base-widget.component';
import {
  Container, Description, TextContainer, Title,
} from './badge-widget.styled';

const BadgeWidget = ({
  title,
  description,
  Icon,
}: BadgeWidgetProps): JSX.Element => {
  return (
    <BaseWidget>
      <Container>
        <div>{ Icon }</div>
        <TextContainer>
          <Title>{ title }</Title>
          <Description>{ description }</Description>
        </TextContainer>
      </Container>
    </BaseWidget>
  );
};

export default BadgeWidget;
